"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textIsEqual = void 0;
function transformText(text, ignoreCase, ignoreRepeatedSpaces, ignoreAllSpaces, trim, trimOperators) {
    let result = text;
    if (trim)
        result = result.trim();
    if (ignoreCase)
        result = result.toLowerCase();
    if (ignoreRepeatedSpaces)
        result = result.replace(/\s+/g, ' ');
    if (ignoreAllSpaces)
        result = result.replace(/\s+/g, '');
    if (trimOperators)
        result = result.replace(/\s*([-+*×÷])\s*/g, '$1');
    return result;
}
function textIsEqual({ text1, text2, ignoreCase, ignoreRepeatedSpaces, ignoreAllSpaces, trim, trimOperators, }) {
    const [processedText1, processedText2] = [text1, text2].map((t) => transformText(t, ignoreCase, ignoreRepeatedSpaces, ignoreAllSpaces, trim, trimOperators));
    return processedText1 === processedText2;
}
exports.textIsEqual = textIsEqual;
